import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../src/OneToOneAdd.css';

const OneToOneAdd = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [invitedBy, setInvitedBy] = useState('');

  // Fetch users and logged-in user's profile when the component mounts
  useEffect(() => {
    const fetchUsersAndProfile = async () => {
      try {
        // Fetch users
        const usersResponse = await fetch(process.env.REACT_APP_SERVER_IP + '/api/admin/user', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (!usersResponse.ok) {
          throw new Error('Failed to fetch users');
        }

        const usersData = await usersResponse.json();

        if (Array.isArray(usersData) && usersData.length > 0) {
          setUsers(usersData);
        } else {
          console.error('No users found or invalid data format');
        }

        // Fetch the logged-in user's profile
        const profileResponse = await fetch(process.env.REACT_APP_SERVER_IP + '/api/admin/my-profile', {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (!profileResponse.ok) {
          throw new Error('Failed to fetch user profile');
        }

        const profileData = await profileResponse.json();

        // Set invitedBy to the logged-in user's name
        if (profileData.firstName && profileData.lastName) {
          setInvitedBy(`${profileData.firstName} ${profileData.lastName}`);
        } else {
          console.error('User profile is missing first or last name');
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsersAndProfile();
  }, []); // Empty dependency array to fetch only once on mount

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = new FormData(event.target);
    const data = {
      date: formData.get('date'),
      // time: formData.get('time'),
      metWith: formData.get('met-with'),
      invitedBy: invitedBy, // Pass invitedBy as it is
      location: formData.get('location'),
      topic: formData.get('topic'),
      userId: localStorage.getItem('userId'),
    };

    try {
      const response = await fetch(process.env.REACT_APP_SERVER_IP + '/api/admin/onetoone', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (response.ok) {
        alert('One-to-One slip added successfully');
      } else {
        console.error('Error from server:', result);
        alert('Error: ' + (result.message || 'Unknown error occurred'));
      }
    } catch (error) {
      console.error('Error during submission:', error);
      alert('An error occurred while submitting the form. Please try again.');
    }
  };

  return (
    <div className="contain">
      <main className="main-content">
        <div className="form-containerOne">
          <h2 className='AddOneToOne'>Add One-To-One</h2>
          <form id="userForm" onSubmit={handleSubmit}  >
            <div className="form-group1">
              <input
                type="date"
                id="date"
                name="date"
                placeholder="Date"
                required
                max={new Date().toISOString().split('T')[0]} // Restrict future dates
              />
            </div>
            {/* <div className="form-group1">
              <input type="time" id="time" name="time" placeholder="Time" required />
            </div> */}

            <div className="form-group1">
              <input
                type="text"
                id="invitedBy"
                name="invitedBy"
                placeholder="Invited By / Initiated By"
                value={invitedBy}
                style={{ backgroundColor: '#e9ebf7' }}
                readOnly
                required
              />
            </div>

            <div>
              <select id="met-with" name="met-with" className="form-group11" required>
                <option value="">Select Met With</option>
                {loading ? (
                  <option>Loading...</option>
                ) : (
                  users.map((user) => {
                    const userName = user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : 'Unknown';
                    return (
                      <option key={user._id} value={user._id}>
                        {userName}
                      </option>
                    );
                  })
                )}
              </select>
            </div>

            <div className="form-group1">
              <input type="text" id="location" name="location" placeholder="Location" required />
            </div>
            <div className="form-group1">
              <input type="text" id="topic" name="topic" placeholder="Topic" required />
            </div>
            <button type="submit" className="btnOne">
              Add One-To-One
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default OneToOneAdd;
